import { cloneDeep } from 'lodash'
import moment from 'moment'
import { detectMobileApp } from 'shared/utils/detectDevice'
import store from 'store2'
import { i18n } from './config'
import { PhoneNumberUtil } from 'components';
import { faFile, faFileExcel, faFileImage, faFilePdf, faFileText, faFileVideo, faFileWord } from '@fortawesome/free-solid-svg-icons'
import { FileExcelOutlined, FileImageOutlined, FileOutlined, FilePdfOutlined, FileTextOutlined, FileWordOutlined, VideoCameraOutlined } from '@ant-design/icons'

const { pathToRegexp } = require("path-to-regexp")

export { default as classnames } from 'classnames';
export { default as config } from './config';
export { Color } from './theme';

export const languages = i18n ? i18n.languages.map(item => item.key) : []
export const defaultLanguage = i18n ? i18n.defaultLanguage : ''

/**
 * Query objects that specify keys and values in an array where all values are objects.
 * @param   {array}         array   An array where all values are objects, like [{key:1},{key:2}].
 * @param   {string}        key     The key of the object that needs to be queried.
 * @param   {string}        value   The value of the object that needs to be queried.
 * @return  {object|undefined}   Return frist object when query success.
 */
export function queryArray(array, key, value) {
  if (!Array.isArray(array)) {
    return
  }
  return array.find(_ => _[key] === value)
}

/**
 * Convert an array to a tree-structured array.
 * @param   {array}     array     The Array need to Converted.
 * @param   {string}    id        The alias of the unique ID of the object in the array.
 * @param   {string}    parentId       The alias of the parent ID of the object in the array.
 * @param   {string}    children  The alias of children of the object in the array.
 * @return  {array}    Return a tree-structured array.
 */
export function arrayToTree(
  array,
  id = 'id',
  parentId = 'pid',
  children = 'children'
) {
  const result = []
  const hash = {}
  const data = cloneDeep(array)

  data.forEach((item, index) => {
    hash[data[index][id]] = data[index]
  })

  data.forEach(item => {
    const hashParent = hash[item[parentId]]
    if (hashParent) {
      !hashParent[children] && (hashParent[children] = [])
      hashParent[children].push(item)
    } else {
      result.push(item)
    }
  })
  return result
}



/**
 * In an array object, traverse all parent IDs based on the value of an object.
 * @param   {array}     array     The Array need to Converted.
 * @param   {string}    current   Specify the value of the object that needs to be queried.
 * @param   {string}    parentId  The alias of the parent ID of the object in the array.
 * @param   {string}    id        The alias of the unique ID of the object in the array.
 * @return  {array}    Return a key array.
 */
export function queryPathKeys(array, current, parentId, id = 'id') {
  const result = [current]
  const hashMap = new Map()
  array.forEach(item => hashMap.set(item[id], item))

  const getPath = current => {
    const currentParentId = hashMap.get(current)[parentId]
    if (currentParentId) {
      result.push(currentParentId)
      getPath(currentParentId)
    }
  }

  getPath(current)
  return result
}

/**
 * In an array of objects, specify an object that traverses the objects whose parent ID matches.
 * @param   {array}     array     The Array need to Converted.
 * @param   {string}    current   Specify the object that needs to be queried.
 * @param   {string}    parentId  The alias of the parent ID of the object in the array.
 * @param   {string}    id        The alias of the unique ID of the object in the array.
 * @return  {array}    Return a key array.
 */
export function queryAncestors(array, current, parentId, id = 'id') {
  const result = [current]
  const hashMap = new Map()
  array.forEach(item => hashMap.set(item[id], item))

  const getPath = current => {
    const currentParentId = hashMap.get(current[id])[parentId]
    if (currentParentId) {
      result.push(hashMap.get(currentParentId))
      getPath(hashMap.get(currentParentId))
    }
  }

  getPath(current)
  return result
}

/**
 * Query which layout should be used for the current path based on the configuration.
 * @param   {layouts}     layouts   Layout configuration.
 * @param   {pathname}    pathname  Path name to be queried.
 * @return  {string}   Return frist object when query success.
 */
export function queryLayout(layouts, pathname) {
  let result = 'public'

  const isMatch = regepx => {
    return regepx instanceof RegExp
      ? regepx.test(pathname)
      : pathToRegexp(regepx).exec(pathname)
  }

  for (const item of layouts) {
    let include = false
    let exclude = false
    if (item.include) {
      for (const regepx of item.include) {
        if (isMatch(regepx)) {
          include = true
          break
        }
      }
    }

    if (include && item.exclude) {
      for (const regepx of item.exclude) {
        if (isMatch(regepx)) {
          exclude = true
          break
        }
      }
    }

    if (include && !exclude) {
      result = item.name
      break
    }
  }

  if (detectMobileApp()) {
    if (result === "public") {
      result = "publicMobileLayout";
    } else if (result !== "noContainer") {
      result = "mobileLayout";
    }
  }

  return result
}


export function getLocale() {
  return store.get('locale') || defaultLanguage
}

export function setLocale(language) {
  if (getLocale() !== language) {
    moment.locale(language === 'zh' ? 'zh-cn' : language)
    store.set('locale', language)
    window.location.reload()
  }
}

export const validatePhoneNumber = (inputNumber) => {

  let valid = false;
  try {
    const phoneUtil = PhoneNumberUtil.getInstance();
    valid = phoneUtil.isValidNumber(phoneUtil.parse(inputNumber));

  } catch (e) {
    valid = false;
  }
  return valid;
}

/***
 * Outline file icon  by File name
 * @author Shaheel navas
 * @parameter filename, classname
 * @return fontawesome Icon
 */
export const getFileIcon = (file, className = '') => {

  let fileType = file.split('.').pop();
  let image = ['png', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'svg'],
    word = ['docs', 'docx'],
    excel = ['xlsx', 'xls'],
    video = ['avi', 'mkv', 'mpeaf', 'gif', 'mov', 'wmv', '3gp', 'flv'],
    text = ['text', 'txt'],
    pdf = ['pdf'];

  if (image.includes(fileType)) {
    return <FileImageOutlined className={`${className} text-info`} />
  } else if (word.includes(fileType)) {
    return <FileWordOutlined className={`${className} text-primary`}/>;
  } else if (video.includes(fileType)) {
    return <VideoCameraOutlined className={`${className} text-warning`}/>
  } else if (excel.includes(fileType)) {
    return <FileExcelOutlined className={`${className} text-success`}/>;
  } else if (text.includes(fileType)) {
    return <FileTextOutlined className={`${className} text-muted`}/>;
  } else if (pdf.includes(fileType)) {
    return <FilePdfOutlined className={`${className} text-danger`}/>;
  } else {
    return <FileOutlined className={`${className} text-secondary`} />;
  }


}

